import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'CallForPricing.label',
    defaultMessage: 'Call for Pricing'
  }
});
